const initialState = {
  inboxList: {},
  inboxDetail: {}
}

const Inbox = (state = initialState, action) => {
  switch (action.type) {
    case "SET_INBOX_LIST":
      state.inboxList = action.payload;
      return state;
    case "SET_INBOX_DETAIL":
        state.inboxDetail = action.payload;
        return state;
    default:
      return state;
  }
};

export default Inbox;
